module.exports = __webpack_public_path__ + "static/media/Laura Swenson.5002b966.png";